import { callPromiseSafely } from "../../util/callPromiseSafely";
import type { TareDeviceModel } from "../types/TareBridge";
import { getTareBridge } from "./getTareBridge";

/**
 * Load the device model from the native module.
 */
export function getDeviceModel(): Promise<TareDeviceModel | null> {
  return callPromiseSafely(getTareBridge()?.getDeviceModel);
}

export function getDeviceModelSync(): TareDeviceModel | null {
  return getTareBridge()?.getDeviceModelSync?.() ?? null;
}
